import api from './api';

/**
 * Catálogos públicos del registro de anunciantes.
 *
 * Se cachean en memoria durante la vida de la página: los tres son estáticos y
 * el wizard los pide desde varios pasos. `divipola` en particular es grande
 * (todos los municipios del país), así que conviene pedirlo una sola vez.
 */
const cache = {
    divipola: null,
    tiposIdentificacion: null,
    categorias: null
};

const enVuelo = {};

function pedirUnaVez(clave, url) {
    if (cache[clave]) {
        return Promise.resolve(cache[clave]);
    }

    // Si dos pasos lo piden a la vez, comparten la misma petición.
    if (enVuelo[clave]) {
        return enVuelo[clave];
    }

    enVuelo[clave] = api
        .get(url)
        .then((respuesta) => {
            const datos = respuesta && respuesta.data ? respuesta.data.data : null;
            cache[clave] = Array.isArray(datos) ? datos : [];
            return cache[clave];
        })
        .catch(() => {
            cache[clave] = [];
            return cache[clave];
        })
        .finally(() => {
            delete enVuelo[clave];
        });

    return enVuelo[clave];
}

export function cargarDivipola() {
    return pedirUnaVez('divipola', 'divipola');
}

export function cargarTiposIdentificacion() {
    return pedirUnaVez('tiposIdentificacion', 'tipo-identificacion');
}

export function cargarCategorias() {
    return pedirUnaVez('categorias', 'categorias-negocio');
}

/**
 * Departamentos únicos, ordenados, a partir del catálogo divipola.
 */
export function departamentosDe(divipola) {
    if (!Array.isArray(divipola) || !divipola.length) return [];

    const unicos = [];
    const vistos = {};

    divipola.forEach((fila) => {
        if (fila.departamento && !vistos[fila.departamento]) {
            vistos[fila.departamento] = true;
            unicos.push(fila.departamento);
        }
    });

    return unicos.sort((a, b) => a.localeCompare(b)).map((d) => ({ label: d, value: d }));
}

/**
 * Municipios de un departamento. Devuelve el `id` de divipola como valor,
 * que es lo que se guarda como FK en la sede.
 */
export function municipiosDe(divipola, departamento) {
    if (!departamento || !Array.isArray(divipola) || !divipola.length) return [];

    return divipola
        .filter((fila) => fila.departamento === departamento)
        .map((fila) => ({ label: fila.municipio, value: fila.id }))
        .sort((a, b) => a.label.localeCompare(b.label));
}

/**
 * Departamento al que pertenece un id de divipola (para rehidratar el
 * formulario al volver atrás o tras un refresco).
 */
export function departamentoDeId(divipola, idDivipola) {
    if (!idDivipola || !Array.isArray(divipola)) return '';
    const fila = divipola.filter((f) => Number(f.id) === Number(idDivipola))[0];
    return fila ? fila.departamento : '';
}
